import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=70a7ea87&"
import script from "./Measurements.vue?vue&type=script&lang=js&"
export * from "./Measurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports